import React from 'react';
import './shared.css';
import Footer from './Footer';
import TopNav from './TopNav';

function CookiesPolicy() {
  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Top Navigation */}
      <TopNav />

      {/* Header Section */}
      <div className="App-header" style={{ background: '#1f2937', minHeight: '20vh' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem', textAlign: 'center' }}>
          Cookies Policy
        </h1>
      </div>

      {/* Main Content */}
      <div className="responsive-px" style={{ paddingTop: '2rem', paddingBottom: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151' }}>
          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>1. What Are Cookies?</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            Cookies are small text files stored on your device by your browser. They are used to remember information about your visit.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>2. How PotatoPapers Uses Cookies</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            PotatoPapers does not directly use cookies. Instead, we use browser localStorage to store your preference for showing or hiding grade boundaries. This is stored locally on your device and never sent to our servers.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>3. Third-Party Cookies</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            When you visit linked YouTube videos, YouTube may use its own cookies and tracking technologies. Please review YouTube's cookie policy for details.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>4. Google Analytics</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            PotatoPapers uses Google Analytics to understand how visitors use the site. Google Analytics uses cookies and similar technologies to collect data such as pages visited, time spent on site, referral sources, and device information. This data helps us improve the site.
          </p>
          <p style={{ marginBottom: '1.5rem' }}>
            Google's data collection practices are governed by their own privacy policy. To opt out of Google Analytics tracking, you can use the <a href="https://tools.google.com/dlpage/gaoptout" style={{ color: '#2563eb', textDecoration: 'none' }}>Google Analytics Opt-out Browser Add-on</a>.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>5. Your Choices</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            You can clear your browser localStorage at any time through your browser settings. This will reset your grade boundary preference.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>6. Changes to This Policy</h2>
          <p>
            We may update this policy at any time. Changes will be posted on this page. Last updated on December 30, 2025.
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default CookiesPolicy;
